import React from 'react';
import ReactDOM from 'react-dom/client';

import { enableMapSet } from 'immer';

import * as ASentry from '@/thirdparty/ASentry';

import App from './App';
import welcome from './welcome';

ASentry.initSentry();
enableMapSet();

function Root() {
  return (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<Root />);

// welcome message for users in the console
welcome();
